module.exports = __webpack_public_path__ + "img/e-cross-logo-bg.cfb27401.png";